/**
 * Resolve the live telemetry SSE URL.
 * Local: same-origin /api (CRA proxy → wesamsambackend on :3000).
 * Deployed site: dedicated API host (same backend used by email/chat).
 */

var DEFAULT_API_ORIGIN = 'https://wesamtechbackend-b1ddf6a12cbc.herokuapp.com';

function isLocalHost() {
  if (typeof window === 'undefined') return true;
  var host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

function originFromChatbotUrl(url) {
  if (!url || typeof url !== 'string') return null;
  try {
    var parsed = new URL(
      url,
      typeof window !== 'undefined' ? window.location.href : undefined
    );
    return parsed.origin;
  } catch (err) {
    return null;
  }
}

function getApiOrigin() {
  if (isLocalHost()) return '';
  return (
    originFromChatbotUrl(process.env.REACT_APP_CHATBOT_URL) || DEFAULT_API_ORIGIN
  ).replace(/\/$/, '');
}

export function getTelemetryStreamUrl() {
  if (process.env.REACT_APP_TELEMETRY_URL) {
    return process.env.REACT_APP_TELEMETRY_URL;
  }

  if (isLocalHost()) {
    return '/api/telemetry/stream';
  }

  return getApiOrigin() + '/api/telemetry/stream';
}

/** Lightweight GET used once per visit so API latency/req counters have a real sample. */
export function getTelemetryHealthUrl() {
  if (process.env.REACT_APP_TELEMETRY_HEALTH_URL) {
    return process.env.REACT_APP_TELEMETRY_HEALTH_URL;
  }

  if (isLocalHost()) {
    return '/api/telemetry/health';
  }

  return getApiOrigin() + '/api/telemetry/health';
}

/** Additive visitor analytics endpoints (do not replace health/stream). */
export function getTelemetryVisitorsUrl() {
  if (process.env.REACT_APP_TELEMETRY_VISITORS_URL) {
    return process.env.REACT_APP_TELEMETRY_VISITORS_URL;
  }

  if (isLocalHost()) {
    return '/api/telemetry/visitors';
  }

  return getApiOrigin() + '/api/telemetry/visitors';
}

export function getTelemetryLocationsUrl() {
  if (process.env.REACT_APP_TELEMETRY_LOCATIONS_URL) {
    return process.env.REACT_APP_TELEMETRY_LOCATIONS_URL;
  }

  if (isLocalHost()) {
    return '/api/telemetry/locations';
  }

  return getApiOrigin() + '/api/telemetry/locations';
}

export function getManifestoApiUrl() {
  if (isLocalHost()) {
    return '/api/manifesto';
  }
  return getApiOrigin() + '/api/manifesto';
}
